import { render, staticRenderFns } from "./ProductDetailBasicInfo.vue?vue&type=template&id=15c59716&scoped=true&"
import script from "./ProductDetailBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailBasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailBasicInfo.vue?vue&type=style&index=0&id=15c59716&prod&scoped=true&lang=css&"
import style1 from "./ProductDetailBasicInfo.vue?vue&type=style&index=1&id=15c59716&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c59716",
  null
  
)

export default component.exports